
export const CHANGE_POPUP_STATS = 'CHANGE_POPUP_STATS';

export const changePopupStats = (data) => {
	return {
		type: CHANGE_POPUP_STATS,
		payload: data,
	};
};